import { TabConfig, NavigationItem, NavigationGroupConfig } from '@/app/navigation/types'
import { PipelineTab } from '@/features/admin/tabs/pipeline'
import { TasksTab } from '@/features/admin/tabs/mes-taches'
import { SearchTab } from '@/features/admin/tabs/search'
import { PaymentTab } from '@/features/admin/tabs/payment'
import { ExpertTab } from '@/features/admin/tabs/expert'
import { IATab } from '@/features/admin/tabs/ia'
import { TrackerTab } from '@/features/admin/tabs/tracker'
import { EmailsTab } from '@/features/admin/tabs/emails'
import { SMSTab } from '@/features/admin/tabs/sms'
import { AppelsTab } from '@/features/admin/tabs/appels'
import { MonEspaceTab } from '@/features/admin/tabs/mon-espace/MonEspaceTab'
import { TicketTab } from '@/features/admin/tabs/ticket'
import { WhatsNewTab } from '@/features/admin/tabs/whats-new'
import { EquipeTab } from '@/features/admin/tabs/equipe'
import { MondayMeetingTab } from '@/features/admin/tabs/monday-meeting'
import { FacturationTab } from '@/features/admin/tabs/facturation'
import { AgentLeaTab } from '@/features/admin/tabs/agent-lea'
import { BoardsTab } from '@/features/admin/tabs/boards'

// Flat tabs array for routing (used by BureauLayout Routes)
export const bureauTabs: TabConfig[] = [
  {
    id: 'whats-new',
    label: 'Nouveautés',
    icon: 'SparklesIcon',
    component: WhatsNewTab,
    path: '/bureau/whats-new',
    position: 0,
    permissions: ['view_dashboard'],
    hidden: true
  },
  {
    id: 'search',
    label: 'Recherche',
    icon: 'DocumentIcon',
    component: SearchTab,
    path: '/bureau/search',
    position: 1,
    permissions: ['view_all_customers', 'view_all_expertises']
  },
  {
    id: 'pipeline',
    label: 'Pipeline',
    icon: 'PipelineIcon',
    component: PipelineTab,
    path: '/bureau/pipeline',
    position: 2,
    permissions: ['view_pipeline', 'bureau_pipeline']
  },
  {
    id: 'tasks',
    label: 'Mes Tâches',
    icon: 'TaskIcon',
    component: TasksTab,
    path: '/bureau/tasks',
    position: 4,
    permissions: ['manage_tasks']
  },
  {
    id: 'payment',
    label: 'Paiements',
    icon: 'DocumentIcon',
    component: PaymentTab,
    path: '/bureau/payment',
    position: 5,
    permissions: ['manage_payments']
  },
  {
    id: 'facturation',
    label: 'Facturation',
    icon: 'DocumentCurrencyEuroIcon',
    component: FacturationTab,
    path: '/bureau/facturation',
    position: 6,
    permissions: ['view_all_customers']
  },
  {
    id: 'expert',
    label: 'Experts',
    icon: 'UserGroupIcon',
    component: ExpertTab,
    path: '/bureau/expert',
    position: 6,
    permissions: ['view_all_customers', 'view_experts']
  },
  {
    id: 'ia',
    label: 'IA',
    icon: 'SparklesIcon',
    component: IATab,
    path: '/bureau/ia',
    position: 7,
    permissions: ['view_dashboard']
  },
  {
    id: 'tracker',
    label: 'Tracker',
    icon: 'ClipboardDocumentCheckIcon',
    component: TrackerTab,
    path: '/bureau/tracker',
    position: 8,
    permissions: ['view_dashboard']
  },
  {
    id: 'agent-lea',
    label: 'Agent Léa',
    icon: 'SparklesIcon',
    component: AgentLeaTab,
    path: '/bureau/agent-lea',
    position: 9,
    permissions: ['view_dashboard']
  },
  {
    id: 'emails',
    label: 'Emails',
    icon: 'EnvelopeIcon',
    component: EmailsTab,
    path: '/bureau/emails',
    position: 9,
    permissions: ['view_dashboard']
  },
  {
    id: 'sms',
    label: 'SMS',
    icon: 'ChatBubbleLeftRightIcon',
    component: SMSTab,
    path: '/bureau/sms',
    position: 10,
    permissions: ['view_dashboard']
  },
  {
    id: 'appels',
    label: 'Appels',
    icon: 'PhoneIcon',
    component: AppelsTab,
    path: '/bureau/appels',
    position: 10.5,
    permissions: ['view_dashboard']
  },
  {
    id: 'ticket',
    label: 'Ticket',
    icon: 'BuildingOfficeIcon',
    component: TicketTab,
    path: '/bureau/ticket',
    position: 10,
    permissions: ['view_dashboard']
  },
  {
    id: 'monday-meeting',
    label: 'Réunion du lundi',
    icon: 'CalendarDaysIcon',
    component: MondayMeetingTab,
    path: '/bureau/monday-meeting',
    position: 11,
    permissions: ['view_dashboard']
  },
  {
    id: 'mon-espace',
    label: 'Mon Espace',
    icon: 'CalendarIcon',
    component: MonEspaceTab,
    path: '/bureau/mon-espace',
    position: 11,
    permissions: ['view_dashboard']
  },
  {
    id: 'equipe',
    label: 'Équipe',
    icon: 'UserGroupIcon',
    component: EquipeTab,
    path: '/bureau/equipe',
    position: 12,
    permissions: ['view_dashboard']
  },
  {
    id: 'boards',
    label: 'Boards',
    icon: 'Squares2X2Icon',
    component: BoardsTab,
    path: '/bureau/boards',
    position: 13,
    permissions: ['view_dashboard']
  }
]

// Grouped navigation structure for NavigationRail
export const bureauNavigation: NavigationItem[] = [
  // Hidden: Whats New (accessed via logo click)
  {
    id: 'whats-new',
    label: 'Nouveautés',
    icon: 'SparklesIcon',
    component: WhatsNewTab,
    path: '/bureau/whats-new',
    position: 0,
    permissions: ['view_dashboard'],
    hidden: true
  } as TabConfig,

  // Group: Dossiers
  {
    id: 'group-dossiers',
    label: 'Dossiers',
    icon: 'FolderIcon',
    position: 1,
    defaultOpen: true,
    children: [
      {
        id: 'search',
        label: 'Recherche',
        icon: 'DocumentIcon',
        component: SearchTab,
        path: '/bureau/search',
        position: 1,
        permissions: ['view_all_customers', 'view_all_expertises']
      },
      {
        id: 'pipeline',
        label: 'Pipeline',
        icon: 'PipelineIcon',
        component: PipelineTab,
        path: '/bureau/pipeline',
        position: 2,
        permissions: ['view_pipeline', 'bureau_pipeline']
      },
      {
        id: 'tracker',
        label: 'Tracker',
        icon: 'ClipboardDocumentCheckIcon',
        component: TrackerTab,
        path: '/bureau/tracker',
        position: 3,
        permissions: ['view_dashboard']
      },
      {
        id: 'agent-lea',
        label: 'Agent Léa',
        icon: 'SparklesIcon',
        component: AgentLeaTab,
        path: '/bureau/agent-lea',
        position: 4,
        permissions: ['view_dashboard']
      }
    ]
  } as NavigationGroupConfig,

  // Group: Travail
  {
    id: 'group-travail',
    label: 'Travail',
    icon: 'ClipboardDocumentCheckIcon',
    position: 2,
    defaultOpen: true,
    children: [
      {
        id: 'tasks',
        label: 'Mes Tâches',
        icon: 'TaskIcon',
        component: TasksTab,
        path: '/bureau/tasks',
        position: 1,
        permissions: ['manage_tasks']
      },
      {
        id: 'emails',
        label: 'Emails',
        icon: 'EnvelopeIcon',
        component: EmailsTab,
        path: '/bureau/emails',
        position: 2,
        permissions: ['view_dashboard']
      },
      {
        id: 'sms',
        label: 'SMS',
        icon: 'ChatBubbleLeftRightIcon',
        component: SMSTab,
        path: '/bureau/sms',
        position: 3,
        permissions: ['view_dashboard']
      },
      {
        id: 'appels',
        label: 'Appels',
        icon: 'PhoneIcon',
        component: AppelsTab,
        path: '/bureau/appels',
        position: 4,
        permissions: ['view_dashboard']
      }
    ]
  } as NavigationGroupConfig,

  // Group: Outils
  {
    id: 'group-outils',
    label: 'Outils',
    icon: 'WrenchScrewdriverIcon',
    position: 3,
    defaultOpen: false,
    children: [
      {
        id: 'payment',
        label: 'Paiements',
        icon: 'BanknotesIcon',
        component: PaymentTab,
        path: '/bureau/payment',
        position: 1,
        permissions: ['manage_payments']
      },
      {
        id: 'facturation',
        label: 'Facturation',
        icon: 'DocumentCurrencyEuroIcon',
        component: FacturationTab,
        path: '/bureau/facturation',
        position: 2,
        permissions: ['view_all_customers']
      },
      {
        id: 'monday-meeting',
        label: 'Réunion du lundi',
        icon: 'CalendarDaysIcon',
        component: MondayMeetingTab,
        path: '/bureau/monday-meeting',
        position: 2,
        permissions: ['view_dashboard']
      },
      {
        id: 'ticket',
        label: 'Ticket',
        icon: 'BuildingOfficeIcon',
        component: TicketTab,
        path: '/bureau/ticket',
        position: 3,
        permissions: ['view_dashboard']
      },
      {
        id: 'ia',
        label: 'IA',
        icon: 'SparklesIcon',
        component: IATab,
        path: '/bureau/ia',
        position: 4,
        permissions: ['view_dashboard']
      },
      {
        id: 'boards',
        label: 'Boards',
        icon: 'Squares2X2Icon',
        component: BoardsTab,
        path: '/bureau/boards',
        position: 5,
        permissions: ['view_dashboard']
      }
    ]
  } as NavigationGroupConfig,

  // Group: Administration
  {
    id: 'group-admin',
    label: 'Administration',
    icon: 'Cog6ToothIcon',
    position: 4,
    defaultOpen: false,
    children: [
      {
        id: 'expert',
        label: 'Experts',
        icon: 'UserGroupIcon',
        component: ExpertTab,
        path: '/bureau/expert',
        position: 1,
        permissions: ['view_all_customers', 'view_experts']
      },
      {
        id: 'equipe',
        label: 'Équipe',
        icon: 'UsersIcon',
        component: EquipeTab,
        path: '/bureau/equipe',
        position: 2,
        permissions: ['view_dashboard']
      },
      {
        id: 'mon-espace',
        label: 'Mon Espace',
        icon: 'CalendarIcon',
        component: MonEspaceTab,
        path: '/bureau/mon-espace',
        position: 3,
        permissions: ['view_dashboard']
      }
    ]
  } as NavigationGroupConfig
]
